import { InjectionToken } from '@angular/core';

export interface VersionManifest {
  commit: string;
  time: string;
}

export interface VersionCheckConfig {
  versionUrl: string;
  throttleMs: number;
  idleBannerMs: number;
  enableIdleBanner: boolean;
}

export const DEFAULT_VERSION_CHECK_CONFIG: VersionCheckConfig = {
  versionUrl: '/version.json',
  throttleMs: 30_000,
  idleBannerMs: 30 * 60_000,
  enableIdleBanner: true,
};

export const VERSION_CHECK_CONFIG = new InjectionToken<VersionCheckConfig>('VERSION_CHECK_CONFIG', {
  providedIn: 'root',
  factory: () => DEFAULT_VERSION_CHECK_CONFIG,
});

// Работа, которую перезагрузка страницы молча потеряет (живая загрузка файлов): пока `true`,
// новая версия не перезагружает вкладку на переходе, а предлагается тостом.
export const VERSION_RELOAD_BLOCKER = new InjectionToken<() => boolean>('VERSION_RELOAD_BLOCKER', {
  providedIn: 'root',
  factory: () => () => false,
});
